import React, { useState, useEffect, useContext } from 'react'
import { MetaTags } from 'react-meta-tags'
import {
    Card,
    Col,
    Container,
    Row,
    CardBody,
    Alert,
} from 'reactstrap'

//**Importing required componant files   */
import Breadcrumb from 'components/Common/Breadcrumb'
import DPTopToolBar from 'framework/widgets/DPTopToolBar'

import { Text } from "../../../framework/validators/TextValidation"
import DPAlert from "../../../framework/widgets/DPAlert"
import DPLoadingAlert from 'framework/widgets/DPLoadingAlert'
import DPPermission from "framework/widgets/DPPermission"

import { Context } from '../../../app-contexts/CommonContexts';
import { useHistory } from 'react-router-dom';


const moment = require('moment');

import DPPrintOption from 'framework/widgets/DPPrintOptions'
import TransactionUpdateContent from './TransactionUpdateContent'
import { getTxnLocations } from '../Transaction/TransactionController'
import { GetTxnTypes, SaveTransaction } from './TransactionUpdateController'
const authToken = localStorage.getItem("authToken")

//**End Importing required componant files */

const TransactionUpdate = (props) => {

    let history = useHistory();
    var time = process.env.REACT_APP_ALERTTIMEOUT
    const ApiURL = window.Links.ApiURL

    const [menuCode, SetMenuCode] = useState("")

    const [show, setShow] = useState(false)
    const [AlertMsg, setAlertMsg] = useState('')
    const [AlertColor, setAlertColor] = useState('')

    const [disabled, setDisabled] = useState(false)

    const [saveEnable, setSaveEnable] = useState(true)
    const [deleteEnable, SetDeleteEnable] = useState(false)
    const [editEnable, SetEditEnable] = useState(false)
    const [Reason, setReason] = useState("Created")

    //Alert Parameter
    const [sweetAlertShow, setsweetAlertShow] = useState(false)
    const [AlertDescription, setAlertDescription] = useState(false)
    const [AlertConfirmOption, setAlertConfirmOption] = useState(0)
    const [ErrorMsg, setErrorMsg] = useState('')
    const [addNew, SetAddNew] = useState(true)
    //*****Menu Rights Start*/
    const [menuAccess, SetMenuAccess] = useState(false)
    const [menuCreate, SetMenuCreate] = useState(false)
    const [menuDelete, SetMenuDelete] = useState(false)
    const [menuModify, SetMenuModify] = useState(false)
    const [menuPrint, SetMenuPrint] = useState(false)
    const [menuProcess, SetMenuProcess] = useState(false)
    const [menuName, SetMenuName] = useState("")
    const [parentName, SetParentName] = useState("")

    const [LocationCode, setLocationCode] = useState("")
    const [locationName, setLocationName] = useState("")
    const [LogUserType, setLogUserType] = useState("")
    const [LogCompanyCode, setLogCompanyCode] = useState("")



    const [loadingAlert, SetLoadingAlert] = useState(false)
    const [loadingAlertTitle, SetLoadingAlerttitle] = useState("")


    //autocode generation related newly added code
    const [nullCode, setNullCode] = useState(false)
    const [autoCode, setAutoCode] = useState(false)

    //User Permission related usestates
    const [permissionAlertShow, setPermissionAlertShow] = useState(false)
    const [permissionAlertTitle, setPermissionAlertTitle] = useState("")
    const [permissionReasonShow, setPermissionReasonShow] = useState(true)
    const [permissionName, setPermissionName] = useState("")
    const [permissionPassword, setPermissionPassword] = useState("")
    const [permissionNameDisable, setPermissionNameDisable] = useState(false)

    const [printoptionShow, setprintoptionShow] = useState(false)

    const [transactionList, setTransactionList] = useState([])
    const [fromLocations, setFromLocations] = useState([])
    const [toLocations, setToLocations] = useState([])

    const [formData, setFormData] = useState({
        selectedTxn: "",
        documentNo: "",
        fromLocation: "",
        toLocation: "",
        initialToLocation: "",
        disableLocations: true,
        disableDocumentNo: false
    })

    //const [ws, setWs] = useState(new WebSocket(`${socketURl}api/WebSocket/ws`));


    //**Permission Granted Alert usestates */

    const [permissionGrantedAlertShow, setPermissionGrantedAlertShow] = useState(false)
    const [permissionGrantedAlertMsg, setPermissionGrantedAlertMsg] = useState("")
    const [permissionGrantedAlertColor, setPermissionGrantedAlertColor] = useState("")

    //import from contexts
    const {
        isHeadOffice, getMenuDetails, masterAuditLog, getSelectedMasterPermissions, fetchAutoCode
    } = useContext(Context);
    //import from contexts


    useEffect(async () => {

        var obj = JSON.parse(localStorage.getItem("authUser"))
        var LogUserType = obj[2]
        var LocationCode = obj[3]
        var LocationName = obj[4]
        var CompanyCode = obj[5]
        var menuDetail = await getMenuDetails(window.location.pathname)
        var menu = menuDetail && menuDetail.menuTag ? menuDetail.menuTag : history.push('/dashboard');
        var parentname = menuDetail?.parentName
        SetParentName(parentname)
        setLocationCode(LocationCode)
        setLocationName(LocationName)
        setLogUserType(LogUserType)
        setLogCompanyCode(CompanyCode)

        var responseData = await getSelectedMasterPermissions(LogUserType, menu)

        SetMenuAccess(responseData.strMenuAccessRight)
        SetMenuCreate(responseData.strMenuCreateRight)
        SetMenuDelete(responseData.strMenuDeleteRight)
        SetMenuModify(responseData.strMenuModifyRight)
        SetMenuPrint(responseData.strMenuPrintRight)
        SetMenuProcess(responseData.strMenuProcessRight)
        SetMenuName(responseData.strMenuName)
        SetMenuCode(responseData.strMenuTag)
        setPermissionReasonShow(responseData.strMenuReasonShow)



    }, [])


    // AuditLog
    useEffect(async () => {

        var obj = JSON.parse(localStorage.getItem("authUser"))
        var LogUserType = obj[2]
        var LocationCode = obj[3]
        var CompanyCode = obj[5]
        var menuDetail = await getMenuDetails(window.location.pathname)
        var menu = menuDetail && menuDetail.menuTag ? menuDetail.menuTag : history.push('/dashboard');

        await masterAuditLog(menu, LogUserType, LocationCode, CompanyCode) //masterfile access log

    }, [])

    useEffect(async () => {

        const response = await GetTxnTypes()
        setTransactionList(response)

    }, [])

    useEffect(async () => {
        if (formData.selectedTxn) {

            var fromLoc = await getTxnLocations(formData.selectedTxn, LogUserType, 1, LocationCode)
            var toLoc = await getTxnLocations(formData.selectedTxn, LogUserType, 0, LocationCode)

            setFromLocations(fromLoc)
            setToLocations(toLoc)
        }
    }, [formData.selectedTxn])

    async function getTransactionData(docNo) {


        if (docNo.length < 1) {
            displayAlertMessage("danger", "Please Enter Document No")
            return
        }

        if (formData.selectedTxn.length < 1) {
            displayAlertMessage("danger", "Please Select Transaction Type")
            return
        }


        try {
            SetLoadingAlert(true)
            SetLoadingAlerttitle("Loading Data...")
            const response = await fetch(`${ApiURL}txn/single/${formData.selectedTxn}/${docNo}/${0}/${LocationCode}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${authToken}`,
                },
            });


            if (response.status == 200) {
                const responseData = await response.json();
                if (responseData.success) {
                    setFormData({
                        ...formData,
                        fromLocation: responseData.data.strHED_LOCFROM,
                        toLocation: responseData.data.strHED_LOCTO,
                        initialToLocation: responseData.data.strHED_LOCTO,
                        disableDocumentNo: true,
                        disableLocations: false
                    })
                } else {
                    displayAlertMessage("danger", "Document No not found")
                }
            } else {
                displayAlertMessage("danger", "Error fetching data")
            }


        } catch (error) {
            console.error('Error:', error);
        } finally {
            SetLoadingAlert(false)
        }


    }

    //save button function
    const handlesave = async () => {

        if (!formData.selectedTxn) {
            displayAlertMessage("danger", "Please Select Transaction Type")
            return
        }

        if (!formData.documentNo) {
            displayAlertMessage("danger", "Please Enter Document No")
            return
        }

        if (!formData.toLocation) {
            displayAlertMessage("danger", "Please Select To Location")
            return
        }

        const formBody = {
            ...formData,
            loginLocation: LocationCode,
            loginUser: LogUserType,
            menuCode: menuCode,
        }

        try {
            SetLoadingAlert(true)
            SetLoadingAlerttitle("Saving Data...")
            const response = await SaveTransaction(formBody)

            if (response.success) {
                displayAlertMessage("success", response.message)
                ClearItem()
            } else {
                displayAlertMessage("danger", response.message)
            }
        } catch (error) {
            console.error('Error:', error);
        } finally {
            SetLoadingAlert(false)
        }

    }


    //edit button function    
    const handleEdit = e => {
        setDisabled(false)
        setSaveEnable(true)
        SetDeleteEnable(true)
        SetEditEnable(false)

    }

    //new button function
    const handleNew = e => {
        // e.preventDefault()
        ClearItem();
        setShow(false)
        setSaveEnable(true)
    }

    //clear fields function    
    const ClearItem = () => {

        setDisabled(false)

        SetAddNew(true)
        setErrorMsg('')
        SetDeleteEnable(false)
        setNullCode(false)

        setReason("Created")
        SetEditEnable(false)
        setSaveEnable(true)
        setPermissionName("")
        setPermissionPassword("")
        setPermissionNameDisable(false)


        setFormData({
            selectedTxn: "",
            documentNo: "",
            fromLocation: "",
            toLocation: "",
            initialToLocation: "",
            disableLocations: true,
            disableDocumentNo: false
        })


    }

    //********Delete button function */
    const handleDelete = () => {
    }


    async function handlePrint(option) {
    }

    const PermissionHandle = (operation) => {


        const permissiondata = {
            "strUsername": permissionName,
            "strPassword": permissionPassword,
            "strLocation": LocationCode,
            "strMenuCode": menuCode
        }

        setPermissionName("")
        setPermissionPassword("")
        setReason("")


        fetch(`${ApiURL}login/userpermission`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${authToken}`
                },
                body: JSON.stringify(permissiondata)
            }
        ).then(Response => {
            if (Response.status == "200") {
                Response.json()
                    .then(responseData => {
                        let Access = (responseData.data.strMenuAccessRight)
                        let Create = (responseData.data.strMenuCreateRight)
                        let Delete = (responseData.data.strMenuDeleteRight)
                        let Modify = (responseData.data.strMenuModifyRight)
                        let Print = (responseData.data.strMenuPrintRight)
                        let Process = (responseData.data.strMenuProcessRight)

                        if (operation == "Save") {
                            if (Create == true) {
                                handlesave()

                            } else if (Modify == true) {
                                handlesave()

                            } else {
                                if (operation == "Save" && addNew == true) {
                                    displayAlertMessage("danger", "This user dosen't have permission to save")
                                } else {
                                    displayAlertMessage("danger", "This user dosen't have permission to edit")
                                }
                            }
                        } else if (operation == "Delete") {
                            if (Delete == true) {
                                handleDelete()

                            } else {
                                displayAlertMessage("danger", "This user dosen't have permission to delete")
                            }
                        } else if (operation == "PDF") {
                            if (Print == true) {
                                handlePrint("PDF")

                            } else {
                                displayAlertMessage("danger", "This user dosen't have permission to print")
                            }
                        } else if (operation == "XCEL") {
                            if (Print == true) {
                                handlePrint("XCEL")

                            } else {
                                displayAlertMessage("danger", "This user dosen't have permission to print")
                            }
                        }
                    })

            } else if (Response.status == "400") {
                Response.json()
                    .then(responseData => {
                        setErrorMsg(responseData.msg)
                    })
                setDisabled(false)
                displayAlertMessage("danger", "Oops something went wrong !")
                setPermissionName("")
                setPermissionPassword("")


            } else if (Response.status == "403") {
                setDisabled(false)
                displayAlertMessage("danger", "You have not Permission to make changes !")
                setPermissionName("")
                setPermissionPassword("")

            } else if (Response.status == "404") {
                Response.json()
                    .then(responseData => {
                        setErrorMsg(responseData.msg)
                    })
                setDisabled(false)
                displayAlertMessage("danger", "Password or User Name is Invalid !")
                setPermissionName("")
                setPermissionPassword("")
            } else {
                ClearItem()
            }
        }).catch(error => {
            console.log(error.message)
        })

        setTimeout(() => {
            setShow(false)
        }, time)
    }





    // Function for displaying Alert Messages.
    function displayAlertMessage(color, message) {
        setAlertColor(color)
        setAlertMsg(message)
        setShow(true)

        setTimeout(() => {
            setShow(false)
        }, time)
    }


    return (
        < React.Fragment >
            <div className="page-content">
                <MetaTags>
                    <title>{menuName}</title>
                </MetaTags>
                <Container fluid={true}>
                    <Breadcrumb title={parentName} breadcrumbItem={menuName}></Breadcrumb>
                    <DPAlert
                        confirm_both={sweetAlertShow}
                        title={menuName}
                        description={AlertDescription}
                        showCancel={true}
                        btnColor={"success"}
                        cancelColor={"danger"}
                        onConfirm={async () => {
                            setsweetAlertShow(false)
                            setPermissionName(LogUserType)
                            if (AlertConfirmOption == 1) {


                                if (addNew == true && menuCreate == true && permissionReasonShow == false) {
                                    handlesave()
                                } else if (addNew == true && menuCreate == true && permissionReasonShow == true) {
                                    setPermissionNameDisable(true)
                                    setPermissionAlertShow(true)
                                } else if (addNew == false && menuModify == true && permissionReasonShow == false) {
                                    handlesave()

                                } else if (addNew == false && menuModify == true && permissionReasonShow == true) {

                                    setPermissionNameDisable(true)
                                    setPermissionAlertShow(true)
                                } else {
                                    if (addNew == false) {

                                    }
                                    setPermissionName("")
                                    setPermissionReasonShow(true)
                                    setPermissionAlertShow(true)
                                }

                            } else if (AlertConfirmOption == 2) {
                                handleEdit()
                            } else if (AlertConfirmOption == 3) {
                                window.location.href = "/";
                            } else if (AlertConfirmOption == 4) {
                                handleNew()
                            } else if (AlertConfirmOption == 5) {

                                if (addNew == false && menuDelete == true && permissionReasonShow == false) {
                                    handleDelete()
                                } else if (addNew == false && menuDelete == true && permissionReasonShow == true) {
                                    setReason("")
                                    setPermissionNameDisable(true)
                                    setPermissionAlertShow(true)
                                } else {
                                    setReason("")
                                    setPermissionName("")
                                    setPermissionReasonShow(true)
                                    setPermissionAlertShow(true)
                                }
                            } else if (AlertConfirmOption == 6) {

                                if (menuPrint == true && permissionReasonShow == false) {
                                    setprintoptionShow(true)
                                } else if (menuPrint == true && permissionReasonShow == true) {
                                    setPermissionNameDisable(true)
                                    setPermissionAlertShow(true)
                                } else {
                                    setPermissionName("")
                                    setPermissionReasonShow(true)
                                    setPermissionAlertShow(true)
                                }
                            }

                        }}
                        onCancel={() => {
                            setsweetAlertShow(false)
                        }}
                    />
                    <DPPermission
                        confirm_both={permissionAlertShow}
                        title={menuName}
                        description={permissionAlertTitle}
                        showReason={permissionReasonShow}
                        nameDisable={false}//{permissionNameDisable}
                        showCancel={true}
                        btnColor={"success"}
                        cancelColor={"danger"}
                        AlName={permissionName}
                        show={permissionGrantedAlertShow}
                        AlertColor={permissionGrantedAlertColor}
                        AlertMsg={permissionGrantedAlertMsg}
                        AlNameOnchange={e => {
                            let val2 = Text(e.target, 50, true, false, "any", false)
                            setPermissionName(val2)
                        }}
                        AlPassward={permissionPassword}
                        AlPasswardOnchange={e => {
                            let val2 = Text(e.target, 50, true, true, "any", false)
                            setPermissionPassword(val2)
                        }}
                        AlReason={Reason}
                        AlReasonOnchange={e => {
                            let val2 = Text(e.target, 50, true, false, "any", true)
                            setReason(val2)
                        }}
                        onConfirm={() => {

                            setPermissionAlertShow(false)
                            if (AlertConfirmOption == 1) {
                                PermissionHandle("Save")
                            } else if (AlertConfirmOption == 5) {
                                PermissionHandle("Delete")
                            } else if (AlertConfirmOption == 6) {
                                setprintoptionShow(true)
                            }
                        }}
                        onCancel={() => {
                            setPermissionAlertShow(false)
                        }}
                    />
                    <DPPrintOption
                        confirm_both={printoptionShow}
                        title={menuName}
                        showCancel={true}
                        cancelColor={"danger"}
                        onConfirmpdf={() => {
                            handlePrint("PDF")
                            setprintoptionShow(false)
                        }}
                        onConfirmxcel={() => {
                            handlePrint("XCEL")
                            setprintoptionShow(false)
                        }}
                        onCancel={() => {
                            setprintoptionShow(false)
                        }}
                    />
                    <DPLoadingAlert
                        confirm_both={loadingAlert}
                        title={loadingAlertTitle}
                    />
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardBody>
                                    <DPTopToolBar
                                        //Help Button
                                        helpEnable={false}
                                        helpClick={() => {
                                            alert("Help")
                                        }}
                                        //Favorite Button
                                        favoriteEnable={false}
                                        favoriteClick={() => {
                                            alert("Favorite")
                                        }}
                                        //New Button
                                        newEnable={true}
                                        newClick={() => {
                                            setAlertDescription("Do you wish to refresh the screen ?");
                                            setAlertConfirmOption(4)
                                            setsweetAlertShow(true)
                                        }}
                                        //Save Button
                                        saveEnable={saveEnable}
                                        saveClick={() => {
                                            setAlertDescription("Do you wish to save ?");
                                            setAlertConfirmOption(1)
                                            setsweetAlertShow(true)
                                        }}
                                        //ProcessButton
                                        processEnable={false}
                                        processClick={() => {
                                            alert("Process")
                                        }}
                                        //Edit Button
                                        editEnable={editEnable && isHeadOffice}
                                        editClick={() => {
                                            setAlertDescription("Do you wish to edit ?");
                                            setAlertConfirmOption(2)
                                            setsweetAlertShow(true)
                                        }}
                                        //Print Button

                                        printEnable={true}
                                        printClick={() => {
                                            setReason("Printed")
                                            setAlertDescription("Do you wish to print ?");
                                            setAlertConfirmOption(6)
                                            setsweetAlertShow(true)
                                        }}
                                        //Delete Button
                                        deleteEnable={deleteEnable}
                                        deleteClick={() => {
                                            setReason("Deleted")
                                            setAlertDescription("Do you wish to delete ?");
                                            setAlertConfirmOption(5)
                                            setsweetAlertShow(true)
                                        }}
                                        //Exit Button
                                        exitEnable={true}
                                        exitClick={() => {
                                            setAlertDescription("Do you wish to exit ?");
                                            setAlertConfirmOption(3)
                                            setsweetAlertShow(true)
                                        }}
                                    />
                                    <Row>
                                        {show ? (
                                            <Alert color={AlertColor} role="alert">
                                                {AlertMsg}
                                            </Alert>
                                        ) : null}
                                    </Row>
                                    <Row>
                                        <TransactionUpdateContent
                                            transactionList={transactionList}
                                            formData={formData}
                                            setFormData={setFormData}
                                            fromLocations={fromLocations}
                                            toLocations={toLocations}
                                            getTransactionData={getTransactionData}
                                        />
                                    </Row>

                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>

        </React.Fragment >
    )

}

export default TransactionUpdate

